/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred during authentication. Please try again.`)
};

const zh_hans1_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证过程中发生错误，请重试。`)
};

const zh_hant1_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證失敗，請再試一次。`)
};

const fr_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue pendant l’authentification. Veuillez réessayer.`)
};

const de_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Authentifizierung ist ein Fehler aufgetreten. Bitte versuche es erneut.`)
};

const ja_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証中にエラーが発生しました。もう一度お試しください。`)
};

const ko_oauth_complete_auth_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증에 실패했습니다. 다시 시도해 주세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const oauth_complete_auth_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oauth_complete_auth_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oauth_complete_auth_error", locale)
	if (locale === "en") return en_oauth_complete_auth_error(inputs)
	if (locale === "zh-Hans") return zh_hans1_oauth_complete_auth_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_oauth_complete_auth_error(inputs)
	if (locale === "fr") return fr_oauth_complete_auth_error(inputs)
	if (locale === "de") return de_oauth_complete_auth_error(inputs)
	if (locale === "ja") return ja_oauth_complete_auth_error(inputs)
	return ko_oauth_complete_auth_error(inputs)
};